
export default class StringUtility {
  /// ====================================================== ///
  static buildReadParams = ({
    offset,
    limit,
    orderBy,
    groupBy,
    sortBy,
    params,
    top,
    id,
    size,
    // createdUserId,
    // name,
    // categoryId,
    // brandIds,
    // statusCodes,
    // whoPaysDelivery,
    type,
  }: // permission,
  // directBuyFlag,
  // choices,
  // onlyMine,
  // inAdFlag,
  {
    offset?: number
    limit?: number
    top?: number
    id?: number
    orderBy?: string
    groupBy?: string
    sortBy?: string
    size?: number
    // createdUserId?: number;
    // name?: string;
    // categoryId?: number;
    // brandIds?: Array<number>;
    // statusCodes?: Array<string>;
    // whoPaysDelivery?: string;
    type?: string
    // permission?: string;
    // directBuyFlag?: number;
    // choices?: Array<number>;
    // onlyMine?: number;
    // inAdFlag?: number;
    params?: Map<string, string>
  }) => {
    const stringBuffer: string[] = []
    let isFirst = true

    if (offset != null) {
      if (isFirst) {
        stringBuffer.push("?")
        isFirst = false
      }
      stringBuffer.push(`offset=${offset}`)
    }
    if (limit != null) {
      if (isFirst) {
        stringBuffer.push("?")
        isFirst = false
      } else {
        stringBuffer.push("&")
      }
      stringBuffer.push(`limit=${limit}`)
    }
    if (top != null) {
      if (isFirst) {
        stringBuffer.push("?")
        isFirst = false
      } else {
        stringBuffer.push("&")
      }
      stringBuffer.push(`top=${top}`)
    }
    if (orderBy != null) {
      if (isFirst) {
        stringBuffer.push("?")
        isFirst = false
      } else {
        stringBuffer.push("&")
      }
      stringBuffer.push(`order-by=${orderBy}`)
    }
    if (groupBy != null) {
      if (isFirst) {
        stringBuffer.push("?")
        isFirst = false
      } else {
        stringBuffer.push("&")
      }
      stringBuffer.push(`groupBy=${groupBy}`)
    }
    if (sortBy != null) {
      if (isFirst) {
        stringBuffer.push("?")
        isFirst = false
      } else {
        stringBuffer.push("&")
      }
      stringBuffer.push(`sort-by=${sortBy}`)
    }
    if (id != null) {
      if (isFirst) {
        stringBuffer.push("?")
        isFirst = false
      } else {
        stringBuffer.push("&")
      }
      stringBuffer.push(`id=${id}`)
    }
    if (size != null) {
      if (isFirst) {
        stringBuffer.push("?")
        isFirst = false
      } else {
        stringBuffer.push("&")
      }
      stringBuffer.push(`size=${size}`)
    }
    if (type != null) {
      if (isFirst) {
        stringBuffer.push("?")
        isFirst = false
      } else {
        stringBuffer.push("&")
      }
      stringBuffer.push(`type=${type}`)
    }
    // if (permission != null) {
    //   if (isFirst) {
    //     stringBuffer.push("?");
    //     isFirst = false;
    //   } else {
    //     stringBuffer.push("&");
    //   }
    //   stringBuffer.push(`permission=${permission}`);
    // }
    // if (directBuyFlag != null) {
    //   if (isFirst) {
    //     stringBuffer.push("?");
    //     isFirst = false;
    //   } else {
    //     stringBuffer.push("&");
    //   }
    //   stringBuffer.push(`directBuyFlag=${directBuyFlag}`);
    // }
    // if (choices != null) {
    //   if (isFirst) {
    //     stringBuffer.push("?");
    //     isFirst = false;
    //   } else {
    //     stringBuffer.push("&");
    //   }
    //   stringBuffer.push(`choices=${choices.toString()}`);
    // }
    // if (onlyMine != null) {
    //   if (isFirst) {
    //     stringBuffer.push("?");
    //     isFirst = false;
    //   } else {
    //     stringBuffer.push("&");
    //   }
    //   stringBuffer.push(`only-mine=${onlyMine}`);
    // }
    // if (inAdFlag != null) {
    //   if (isFirst) {
    //     stringBuffer.push("?");
    //     isFirst = false;
    //   } else {
    //     stringBuffer.push("&");
    //   }
    //   stringBuffer.push(`inAdFlag=${inAdFlag}`);
    // }
    if (params != null) {
      params.forEach((value, key) => {
        if (value !== "undefined" && value !== "") {
          if (isFirst) {
            stringBuffer.push("?")
            isFirst = false
          } else {
            stringBuffer.push("&")
          }
          stringBuffer.push(`${key}=${value}`)
        }
      })
    }

    return stringBuffer.join("")
  }

  /// ====================================================== ///
  static isValidText = (text: string) => {
    if (text !== undefined && text !== null && text !== "") {
      return true
    }
    return false
  }

  /// ====================================================== ///
  static isValidEmail = (email: string) => {
    if (this.isValidText(email)) {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(email)
    }
    return false
  }

  static isNum = (text: string) => {
    if (this.isValidText(text)) {
      return /^[0-9]+$/.test(text)
    }
    return false
  }

  /// ====================================================== ///
  static isNumeric = (text: string) => {
    if (this.isValidText(text)) {
      return !isNaN(Number.parseFloat(String(text)))
    }
    return false
  }

  /// ====================================================== ///
  static vistaToNumber = (n: number) => {
    n = n / 100
    return n
  }

  /// ====================================================== ///
  static toVistaCents = (n: number) => {
    return Math.floor(n * 100)
  }

  /// ====================================================== ///
  static numberToCurrency = (number: number, currency?: string) => {
    return (
      new Intl.NumberFormat("mn", {
        notation: "standard",
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      }).format(number) + (currency ?? "₮")
    )
  }

  /// ====================================================== ///
  static currencyToNumber = (currency: string) => {
    if (this.isValidText(currency)) {
      return Number(currency.replace(/[^0-9-]+/g, ""))
    }
    return 0
  }

  /// ====================================================== ///
  static mnNameFormat = ({
    firstname,
    lastname,
  }: {
    firstname: string
    lastname: string
  }) => {
    let name = ""

    if (lastname.length < 1) {
      name += "н."
    } else {
      name += lastname.charAt(0) + "."
    }

    if (firstname.length < 1) {
      name += "хэрэглэгч"
    } else {
      name += firstname
    }

    return name
  }
  // static split

  /// ====================================================== ///
  static padTo2Digits = (num: number) => {
    return num.toString().padStart(2, "0")
  }

  /// ====================================================== ///
  static getDateAsLocal = (date: Date | undefined) => {
    if (date === undefined) return ""
    return (
      [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-") +
      " " +
      [
        this.padTo2Digits(date.getHours()),
        this.padTo2Digits(date.getMinutes()),
        this.padTo2Digits(date.getSeconds()),
      ].join(":")
    )
  }

  static minimumIntDigits = (value: number, digitLength?: number) => {
    if (digitLength === undefined) {
      digitLength = 2
    }
    return value.toLocaleString(undefined, {
      minimumIntegerDigits: digitLength,
    })
  }

  /// ====================================================== ///
  static vistaDateToDate = (date: string) => {
    const regex = /d+/
    const timestamp = Number.parseInt(date.match(regex)?.join("") ?? "0")
    return new Date(timestamp)
  }

  static validationRegNo = (regNo: string) => {
    const regex = /([А-Я|Ө|Ү]{2})(\d{8})/
    return regex.test(regNo)
  }

  static isValidName = (value: string) => {
    const regex = /^[a-zA-Z-]*$/
    if (regex.test(value)) return true
    return false
  }

  /// ====================================================== ///
  static stringInsert = (value:string, index:number, add:string) => {
    let newStr = (value.split("")).reduce((a, b, n) => {
      return n === index ? a + add + b : a + b
    }, '')
    return newStr
  }
}